var log = require('../libraries/logger').getLoggerInstance('Base.Main.BrowserUtility');

var publicMethods = {
  getBrowserDetails: function () {
    var userAgent = navigator.userAgent, version, userAgentRegexMatch = userAgent.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    var browser = {
      "name": '',
      "version": ''
    };

    if (/trident/i.test(userAgentRegexMatch[1])) {
      version = /\brv[ :]+(\d+)/g.exec(userAgent) || [];
      browser.name = 'IE';
      browser.version = version[1];
    }

    if (userAgentRegexMatch[1] === 'Chrome') {
      version = userAgent.match(/\bOPR\/(\d+)/);
      if (version != null) {
        browser.name = 'Opera';
        browser.version = version[1];
      }
    }

    userAgentRegexMatch = userAgentRegexMatch[2] ? [userAgentRegexMatch[1], userAgentRegexMatch[2]] : [navigator.appName, navigator.appVersion, '-?'];

    if ((version = userAgent.match(/version\/(\d+)/i)) != null) {
      userAgentRegexMatch.splice(1, 1, version[1]);
    }

    browser.name = userAgentRegexMatch[0];
    browser.version = userAgentRegexMatch[1];
    browser.isMobileViewport = publicMethods.isMobileViewport();

    return browser;
  },
  isMobileViewport: function () {
    if (window.matchMedia) {
      if (publicMethods.isMobileSafari()) {
        if (window.matchMedia('(max-device-width:767px)').matches) {
          return true;
        }
      } else {
        if (window.matchMedia('(max-device-width:799px) and (orientation:portrait)').matches || window.matchMedia('(max-device-width:1023px) and (orientation:landscape)').matches) {
          return true;
        }
      }
    } else {
      log.debug("Media Queries are not supported by this browser, defaulting to desktop");
    }

    return false;
  },
  isMobileSafari: function () {
    if (navigator.userAgent.search('iPad|iPhone|iPod', 'i') >= 0) {
      return true;
    }
    return false;
  }
};

module.exports = publicMethods;


//////////////////
// WEBPACK FOOTER
// ./utilities/browserUtility.js
// module id = 23
// module chunks = 5